import axios from "axios";

export default {
    getVisibleClients: async () => {
        const { data } = await axios.get('/clients/', {
            params: {
                visible: 1
            }
        })

        return data
    },
    getClientsList: async (params) => {
        const { data } = await axios.get('/clients_list', {
            params
        })

        return data
    }
}